import React, { useCallback } from 'react'
import { getPlayerCoinHistoryBlueday, getPlayerGameHistoryBlueday } from '../../Api/UserPanel/UserPanel'
import Swal from 'sweetalert2';

export const useCheckBonifications = () => {

    const breakpointBonification = 10000;

    const checkNonUsedBonificationsGrenbet = useCallback(async ({ name, quantity }: { name: string, quantity: string }) => {

        const nameToSearch = name?.trim()
        const responseCoins = await getPlayerCoinHistoryBlueday({ name: nameToSearch })
        const resultsCoins = responseCoins?.data?.data;
        const raw = responseCoins?.data?.TotalAmount; // "2.174,00"
        const clean = raw.replace(/\./g, '').replace(',', '.'); // "2174.00"
        const totalAmount = Number(clean);


        if (Number(quantity) > totalAmount) {
            return {
                success: false,
                message: 'quantity-error',
                nonUsedBonifications: [],
                gamesData: [],
                coinsData: [],
                totalAmount: totalAmount,
            }
        }

        let gamesData: any[] = [];

        const revertedResults = [...resultsCoins].reverse();
        let filteredNonUsedBonifications: any[] = [];

        if (Number(totalAmount) > breakpointBonification && resultsCoins?.some((item: any) => item?.[3]?.toLowerCase() === 'bonificacion')) {

            const responseGames = await getPlayerGameHistoryBlueday({ name: nameToSearch, page: 1 })
            const resultsGames = responseGames?.data?.data;
            gamesData = [...resultsGames];

            const onlyBonifications = revertedResults?.filter((item: any) => item?.[3]?.toLowerCase() === 'bonificacion');
            console.log('onlyBonifications', onlyBonifications)

            onlyBonifications?.forEach((itemBonification: any) => {
                const itemDate = new Date(itemBonification?.[0]);
                const filteredByDate = resultsGames?.filter((itemGame: any) => new Date(itemGame?.[0]) >= itemDate);
                const filterAdd = filteredByDate?.filter((itemGame: any) => itemGame?.[4]?.toLowerCase() !== 'credit add');
                const filterSubtract = filterAdd?.filter((itemGame: any) => itemGame?.[4]?.toLowerCase() !== 'credit out');


                if (filterSubtract?.some((itemGame: any) => Number(itemGame?.[7].replace('$', '')) < breakpointBonification)) {
                    // No hacer nada, el usuario ya uso la bonificacion
                }
                else {
                    filteredNonUsedBonifications.push(itemBonification);
                }
            })

        } else {
            return {
                success: false,
                message: 'Bonificación no encontrada',
                nonUsedBonifications: [],
                gamesData: [],
                coinsData: [],
                totalAmount: totalAmount,
            }
        }

        const data = {
            success: true,
            message: 'Bonificación sin usar encontrada',
            nonUsedBonifications: filteredNonUsedBonifications,
            gamesData: gamesData,
            coinsData: resultsCoins,
            totalAmount: totalAmount,
        }

        return data
    }, [])


    return {
        checkNonUsedBonificationsGrenbet,
    }
}